<template>
  <div class="grid-list-header">
    <div>
      <h2>{{ title }}</h2>
      <p>{{ total }} {{ total === 1 ? singularLabel : pluralLabel }} {{ matchLabel }}.</p>
    </div>
    <span v-if="loading" class="loading-label"><span class="loading-spinner" />Atualizando</span>
  </div>
</template>

<script>
export default {
  name: 'GridListHeader',
  props: {
    title: { type: String, required: true },
    total: { type: Number, default: 0 },
    singularLabel: { type: String, default: 'registro' },
    pluralLabel: { type: String, default: 'registros' },
    feminine: { type: Boolean, default: false },
    loading: { type: Boolean, default: false }
  },
  computed: {
    matchLabel () { return this.total === 1 ? (this.feminine ? 'encontrada' : 'encontrado') : (this.feminine ? 'encontradas' : 'encontrados') }
  }
}
</script>
